module.exports = __webpack_public_path__ + "files/4ae99f0d102bc2c34f78966312c26457.png";